import Partner from "@/components/Partner";
import React, { FC } from "react";

const PartnerWithUs: FC = () => <Partner />;

export default PartnerWithUs;
